import React from "react"
import Form, { Item, CompareRule, ButtonItem } from "devextreme-react/form"

class ChangePassword extends React.PureComponent {
	constructor(props) {
		super(props)
		this.state = { ...props }
		if (this.state.dataChangePassword === undefined)
			this.state.dataChangePassword = {
				old: "",
				new: "",
				confirm: ""
			}
	}
	submitChangePassword = (e) => {
		e.preventDefault()
		this.state.fn.post({
			url: "password",
			data: this.state.dataChangePassword,
			success: this.state.fn.closeModal
		})
	}
	render() {
		return (
			<form onSubmit={this.submitChangePassword}>
				<Form formData={this.state.dataChangePassword}>
					<Item
						dataField="old"
						editorOptions={{ mode: "password" }}
						label={{ location: "top", text: "Password Lama" }}
						isRequired={true}
					/>
					<Item
						dataField="new"
						editorOptions={{ mode: "password" }}
						label={{ location: "top", text: "Password Baru" }}
						isRequired={true}
					/>
					<Item
						dataField="confirm"
						editorOptions={{ mode: "password" }}
						label={{ location: "top", text: "Confirm Password" }}
						isRequired={true}
					>
						<CompareRule
							message="Password and Confirm Password do not match"
							comparisonTarget={(e) => {
								return this.state.dataChangePassword.new
							}}
						/>
					</Item>
					<ButtonItem
						horizontalAlignment="left"
						buttonOptions={{
							text: "Ubah Password",
							type: "success",
							icon: "save",
							useSubmitBehavior: true,
							width: 200
						}}
					/>
				</Form>
			</form>
		)
	}
}

export default ChangePassword
